import Vue from "vue";

export default function(text) {
  Vue.notify({
    title: text,
    type: "error",
  });
}